import { render } from "./Case.vue?vue&type=template&id=1c60bb95&scoped=true"
const script = {}

import "./Case.vue?vue&type=style&index=0&id=1c60bb95&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev-En\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c60bb95"]])

export default __exports__